import React, { useState, useRef, useEffect } from 'react';
import { Box, IconButton, Switch } from '@mui/material';
import { Settings } from '@mui/icons-material';
import { CALENDAR_COLOR_OPTIONS } from '../../../shared/appConstants';
import './CalendarView.scss';

const CalendarSettings = ({ selectedOption, onOptionChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const handleToggle = (optionId) => {
    onOptionChange(selectedOption === optionId ? null : optionId);
  };

  return (
    <Box className="calendar-settings" ref={dropdownRef}>
      <IconButton 
        className="calendar-settings-icon"
        onClick={() => setIsOpen(!isOpen)}
        size="small"
      >
        <Settings />
      </IconButton>

      {isOpen && (
        <Box className="calendar-settings-dropdown">
          {CALENDAR_COLOR_OPTIONS.map((option) => (
            <Box key={option.id} className="calendar-settings-item">
              <span className="calendar-settings-label">{option.label}</span>
              <Switch
                checked={selectedOption === option.id}
                onChange={() => handleToggle(option.id)}
                size="small"
              />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CalendarSettings;
